import styled from "styled-components";
import "../../styles/base";
import { media } from "../../styles/utils";

export const Footer = styled.div.attrs({ className: "footer_wrapper" })`
  position: relative;
  border-top: 1px solid white;
  width: 87.5%;
  margin: 0 auto;
  margin-top: 150px;
  padding: 39px 0 40px;

  ${media.forDesktopOnly`
    width: 100%;
    margin: 0;
    margin-top: 250px;
    padding: 0 40px;
  `}
`;
export const FooterLinks = styled.div`
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  max-width: 150px;
  margin-top: 40px;
  a {
    display: block;
    margin-bottom: 10px;
    color: white;
    text-decoration: none;
  }
  .footer-element-phone {
    /* position: absolute;
    top: 41px;
    left: 0; */
    max-width: 150px;
  }  
  ${media.forDesktopOnly`
    font-size: 12px;
    max-width: none;
    text-align: right;
    margin-top: 25px;
    margin-bottom: 25px;
    a {
      display: inline-block;
      margin-left: 40px;
    }
    .footer-element-phone {
      position: static;
      max-width: none;
      br {
        display: none;
      }
    }
  `};
`;
export const FooterIcon = styled.div`
  position: absolute;
  right: 0;
  img {
    height: 20px;
    width: 20px;
  }  
  ${media.forDesktopOnly`
    right: auto;
    left: 40px;
    top: 19px;
  `};
`;



// WEBPACK FOOTER //
// ./src/layouts/app_footer/styled_app_footer.js